'use client'

import { reportClientError } from '@utils/clientErrors'
import NextError from 'next/error'
import { useEffect } from 'react'

export default function GlobalError({ error }) {
  useEffect(() => {
    console.log('capturing global error', error)
    reportClientError(error, { tags: { source: 'global-error-boundary' } })
  }, [error])

  return (
    <html>
      <body>
        <NextError />
      </body>
    </html>
  )
}
